export const appConfig = {
  role: {
    ADMIN: 'ADMIN',
    PARENT: 'PARENT',
    SCHOOL: 'SCHOOL',
    STUDENT: 'STUDENT',
    TEACHER: 'TEACHER',
    SCHOOL_OWNER: 'SCHOOL_OWNER',
  } as const,
};
